export default __webpack_public_path__ + "static/media/recent.e237c50d.svg";